/**
 * @fileoverview PUT handler for the "/databricks_deltashares/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putDeltasharesCacheKeys } from "./constants";
import type { MutateDeltasharesResult, PutDeltasharesProps } from "./types";

export const putDeltashares = reactQueryMutationAdapter(
  putDeltasharesCacheKeys,
  (props: PutDeltasharesProps): Promise<MutateDeltasharesResult> => {
    return fetch(`/databricks_deltashares/${props.appGroupId}`, "PUT", props.datashare, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
